module.exports = __webpack_public_path__ + "static/media/2.ca5d468f.mp4";